var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDashboardAndStatistics = function SvgDashboardAndStatistics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 41 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100.315
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Search results for Dashboard - Flaticon-3 (1)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3287"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7289",
    d: "M92.38 0H7.649A7.657 7.657 0 0 0 0 7.649v64.353a7.657 7.657 0 0 0 7.649 7.648h28.25l-3.793 9.364h-5.461a5.65 5.65 0 1 0 0 11.3h46.71a5.65 5.65 0 1 0 0-11.3h-5.461l-3.793-9.364h28.25A7.657 7.657 0 0 0 100 72.001V7.649A7.61 7.61 0 0 0 92.38 0Zm-16.1 94.665a2.9 2.9 0 0 1-2.9 2.9H26.66a2.9 2.9 0 1 1 0-5.792h46.711a2.912 2.912 0 0 1 2.912 2.9Zm-11.331-5.65H35.08l3.793-9.364h22.269ZM97.28 72.002a4.9 4.9 0 0 1-4.9 4.894H7.649a4.9 4.9 0 0 1-4.895-4.895V7.649a4.9 4.9 0 0 1 4.895-4.895h84.718a4.9 4.9 0 0 1 4.895 4.895v64.353Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7290",
    d: "M92.383 6.264H7.649a1.387 1.387 0 0 0-1.385 1.385v54.926a1.387 1.387 0 0 0 1.385 1.385h84.715a1.387 1.387 0 0 0 1.385-1.385V7.649a1.374 1.374 0 0 0-1.366-1.385Zm-1.385 54.942H9.034V9.018h81.964Z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 59",
    cx: 1.574,
    cy: 1.574,
    r: 1.574,
    transform: "translate(48.442 67.941)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7291",
    d: "M28.707 44.822a16.132 16.132 0 1 0-16.132-16.116 16.154 16.154 0 0 0 16.132 16.116Zm0-2.754a13.283 13.283 0 0 1-8.42-3.006l9-9h12.734a13.4 13.4 0 0 1-13.314 12.006Zm13.314-14.747h-11.93V15.392a13.4 13.4 0 0 1 11.93 11.929ZM27.337 15.392v12.732l-9 9a13.36 13.36 0 0 1 9-21.734Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7292",
    d: "M49.244 57.648h7.554a1.387 1.387 0 0 0 1.385-1.385v-14.4a1.387 1.387 0 0 0-1.385-1.385h-7.554a1.387 1.387 0 0 0-1.385 1.385v14.4a1.377 1.377 0 0 0 1.385 1.385Zm1.369-14.4h4.8v11.646h-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7293",
    d: "M70.648 31.051h-7.554a1.387 1.387 0 0 0-1.385 1.385v23.843a1.387 1.387 0 0 0 1.385 1.385h7.554a1.387 1.387 0 0 0 1.385-1.385V32.42a1.394 1.394 0 0 0-1.385-1.369Zm-1.385 23.84h-4.8V33.805h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7294",
    d: "M84.498 45.231h-7.554a1.387 1.387 0 0 0-1.385 1.385v9.679a1.387 1.387 0 0 0 1.385 1.385h7.554a1.387 1.387 0 0 0 1.385-1.385v-9.679a1.377 1.377 0 0 0-1.385-1.385Zm-1.369 9.663h-4.8v-6.925h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7295",
    d: "M13.96 51.039h25.039a1.385 1.385 0 0 0 0-2.77H13.96a1.385 1.385 0 1 0 0 2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7296",
    d: "M13.96 57.649h14.747a1.385 1.385 0 0 0 0-2.77H13.96a1.385 1.385 0 0 0 0 2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7297",
    d: "M49.244 33.806a1.333 1.333 0 0 0 .976-.409l13.236-13.236 12.512 12.512a1.387 1.387 0 0 0 1.952 0l7.4-7.4v1.023a1.385 1.385 0 0 0 2.77 0v-4.58a1.387 1.387 0 0 0-1.385-1.385h-4.58a1.385 1.385 0 0 0 0 2.77h1.5l-6.657 6.657-12.521-12.509a1.387 1.387 0 0 0-1.952 0L48.284 31.461a1.387 1.387 0 0 0 0 1.952 1.357 1.357 0 0 0 .96.393Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1604",
    fill: "none",
    d: "M0 0h100v100H0z"
  })));
};
export default SvgDashboardAndStatistics;